import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

const Tabs = TabsPrimitive.Root

// The strip scrolls inside itself, never the page, and it starts at the tab you
// are actually on — landing on a strip already scrolled past your own tab is
// worse than no scrolling at all.
const TabsList = React.forwardRef(({ className, ...props }, ref) => {
  const wrap = React.useRef(null)
  React.useEffect(() => {
    const active = wrap.current?.querySelector('[data-state="active"]')
    active?.scrollIntoView({ inline: "nearest", block: "nearest" })
  }, [])
  return (
    <div ref={wrap} className="tabstrip -mx-4 px-4 sm:mx-0 sm:px-0">
      <TabsPrimitive.List
        ref={ref}
        className={cn(
          "inline-flex h-9 w-max items-center justify-start rounded bg-muted p-1 text-muted-foreground",
          className
        )}
        {...props} />
    </div>
  )
})
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded px-3 py-1 text-body font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:font-semibold data-[state=active]:text-borstel",
      className
    )}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
